<!--
 * @Author: gaozexiong RJgaozexiong@ruijie.com.cn
 * @Date: 2022-07-27 15:10:09
 * @LastEditors: gaozexiong RJgaozexiong@ruijie.com.cn
 * @LastEditTime: 2022-09-16 15:31:52
 * @FilePath: \ces-vue-serve\src\views\contractCommonInput\exportCountry.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <div class="rj-col-3">
      <div class="rj-baseinfo">
        <div class="rj-baseinfo__label">
          销往区域<span v-if="required" class="required">*</span>：
        </div>
        <div class="rj-baseinfo__item">
          <el-form-item prop="soldCountry">
            <el-select v-model="form.soldCountry" :disabled="disabled" placeholder="销往区域" style="width:100%;" @change="changeCountry">
              <el-option v-for="(value, key) in countryList" :key="key" :label="value.constantValue" :value="value.constantValue" />
            </el-select>
          </el-form-item>
        </div>
      </div>
    </div>
    <!--if: 用于控制国际服务独立销售的单据是否展示电源线规格-->
    <div v-if="isShowInternationalServiceOrders!== 1" class="rj-col-3">
      <div class="rj-baseinfo">
        <div class="rj-baseinfo__label">
          电源线规格(2pin)<span v-if="required" class="required">*</span>：
        </div>
        <div class="rj-baseinfo__item">
          <el-form-item prop="powerCordSpecification">
            <el-select v-model="form.powerCordSpecification" :disabled="disabled" style="width:100%;">
              <el-option v-for="(value, key) in twoPinPowerCordList" :key="key" :label="value.constantName" :value="value.constantName" />
            </el-select>
          </el-form-item>
        </div>
      </div>
    </div>
    <!--if: 用于控制国际服务独立销售的单据是否展示电源线规格-->
    <div v-if="isShowInternationalServiceOrders!== 1" class="rj-col-3">
      <div class="rj-baseinfo">
        <div class="rj-baseinfo__label">
          电源线规格(3pin)<span v-if="required" class="required">*</span>：
        </div>
        <div class="rj-baseinfo__item">
          <el-form-item prop="powerCordSpecification">
            <el-select v-model="form.threePlugPowerCord" :disabled="disabled" style="width:100%;">
              <el-option v-for="(value, key) in threePinPowerCordList" :key="key" :label="value.constantName" :value="value.constantName" />
            </el-select>
          </el-form-item>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="es6">
import { getCountryOrSpecificationPowerCord } from '@/API';
import eventBus from '@/libs/eventBus.js';
export default {
  data () {
    return {
      countryList: [],
      twoPinPowerCordList: [],
      threePinPowerCordList: [],
      isShowInternationalServiceOrders: 0// 是否是国际服务订单,0国内,1国际,用于控制电源线组件是否显示
    };
  },
  model: {
    prop: 'form',
    event: 'change'
  },
  props: {
    form: {
      type: Object,
      default: () => { return {}; }
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  components: {
  },
  computed: {},
  methods: {
    initCountry () {
      // 如果是国际服务订单,不展示电源线规则,所以不调用接口
      if (this.isShowInternationalServiceOrders === 1) return;
      getCountryOrSpecificationPowerCord('').then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.countryList = json.data.soldCountryList;
        }
      }).catch(() => {

      });
    },
    changeCountry (val, hasInit) {
      this.twoPinPowerCordList = [];
      this.threePinPowerCordList = [];
      if (!hasInit) {
        this.form.powerCordSpecification = '';
        this.form.threePlugPowerCord = '';
      }
      // 如果是国际服务订单,不展示电源线规则,所以不调用接口
      if (this.isShowInternationalServiceOrders === 1) return;
      getCountryOrSpecificationPowerCord(val, null).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          const { twoPinPowerCordList, threePinPowerCordList } = json.data;
          this.twoPinPowerCordList = twoPinPowerCordList;
          this.threePinPowerCordList = threePinPowerCordList;
          this.$emit('handleChange');
          eventBus.$emit('changePowerCord', {
            powerCordData: json.data
          });
        }
      }).catch(() => {

      });
    },
    initData () {
      if (this.form.soldCountry) {
        this.changeCountry(this.form.soldCountry, true);
      }
    }
  },
  created () {
    this.isShowInternationalServiceOrders = Number(this.$route.query.isShowInternationalService);
  },
  mounted () {
    this.initCountry();
    this.initData();
  },
  beforeDestroy () {
  }
};
</script>
